import { createAction, props } from '@ngrx/store';
import { RequestAddressManagerCreate, ResponseAddressManagerCreate } from '../../shared/interfaces';
import { AddressManagerCreateTypes } from '../../shared/enums';

export const getAddressManagerCreate = createAction(
    AddressManagerCreateTypes.ADDRESS_MANAGER_CREATE,
    props<{ request: RequestAddressManagerCreate}>()
);

export const getAddressManagerCreateSucess = createAction(
    AddressManagerCreateTypes.ADDRESS_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseAddressManagerCreate }>()
);

export const getAddressManagerCreateError = createAction(
    AddressManagerCreateTypes.ADDRESS_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    AddressManagerCreateTypes.CLEAN_STATE
);

